import { connect } from 'react-redux';

import SummarySection from 'scheduleModule/components/SummarySection';

export default connect(state => ({
  summary: state.schedule.summary,
}))(SummarySection);
